import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import WalletMainWhitelistList from "./WalletMainWhitelistList";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import WalletMainWhitelistFilter from "./WalletMainWhitelistFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import DialogModal from "../../elements/dialogModal/DialogModal";
import TwoFa from "../../elements/twoFa/TwoFa";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import CreateWalletMainWhitelistButton from "./CreateWalletMainWhitelistButton";
import { useTranslation } from "react-i18next";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledWalletMainWhitelistWrapper } from "../styledWalletMainWhitelist";

const WalletMainWhitelistContainer = () => {
  const { t } = useTranslation("walletWhitelistPage");

  const [walletMainWhitelist, setWalletMainWhitelist] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [error, setError] = useState({});

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteSubmitData, setDeleteSubmitData] = useState({
    id: null
  });

  const [openActivity, setOpenActivity] = useState(false);
  const [activitySubmitData, setActivitySubmitData] = useState({
    id: null,
    isActive: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "user.id": checkFilterItem(history, "user.id", null),
    "user.email": checkFilterItem(history, "user.email", null),
    "currency": checkFilterItem(history, "currency", null),
    "paymentSystem": checkFilterItem(history, "wallet", null),
    "wallet": checkFilterItem(history, "wallet", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchWalletMainWhitelist = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/wallet-main-white-lists" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setWalletMainWhitelist(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleRemoveWallet = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.delete("/api/wallet-main-white-lists/" + deleteSubmitData.id, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setOpenDelete(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.deleteMessage") });
      }
    }).catch(error => {
      setOpenDelete(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleChangeActivity = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.patch("/api/wallet/main-whitelist/activity/" + activitySubmitData.id, { isActive: activitySubmitData.isActive }, userAuthenticationConfig()).then((response) => {
      if (response.status === 200 || response.status === 204) {
        setOpenActivity(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.activityMessage") });

      }
    }).catch((error) => {
      setOpenActivity(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchWalletMainWhitelist();
  }, [filterData, notification]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };
  return (
    <>
      <DialogModal
        open={openDelete}
        setOpen={setOpenDelete}
        title={t("table.twoFa")}
        content={<TwoFa
          handleSubmit={handleRemoveWallet}
          error={error}
        />}
      />
      <DialogModal
        open={openActivity}
        setOpen={setOpenActivity}
        title={t("table.twoFa")}
        content={
          <TwoFa
            handleSubmit={handleChangeActivity}
            error={error}
          />
        }
      />

      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledWalletMainWhitelistWrapper>
          <div className="wallet-main-whitelist-head">
            <WalletMainWhitelistFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <CreateWalletMainWhitelistButton
              notification={notification}
              setNotification={setNotification}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <WalletMainWhitelistList
            walletMainWhitelist={walletMainWhitelist}
            setOpenDelete={setOpenDelete}
            deleteSubmitData={deleteSubmitData}
            setDeleteSubmitData={setDeleteSubmitData}
            setOpenActivity={setOpenActivity}
            activitySubmitData={activitySubmitData}
            setActivitySubmitData={setActivitySubmitData}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledWalletMainWhitelistWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default WalletMainWhitelistContainer;